import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';
import { Tooltip } from '@fluentui/react-components';
import { ReOrderDotsVerticalRegular } from '@fluentui/react-icons';

type TProps = {
  /** Why reordering is unavailable right now; shown instead of the drag hint. */
  disabledReason?: string;
};

const DragHandle = forwardRef<HTMLSpanElement, TProps>(function DragHandle(
  { disabledReason }: TProps,
  ref: ForwardedRef<HTMLSpanElement>
) {
  return (
    <Tooltip content={disabledReason || 'Drag to reorder'} relationship="label" withArrow>
      <span
        ref={ref}
        className={classNames(
          'flex',
          disabledReason ? 'cursor-not-allowed opacity-50' : 'cursor-grab active:cursor-grabbing'
        )}
      >
        <ReOrderDotsVerticalRegular />
      </span>
    </Tooltip>
  );
});

export default DragHandle;
